import { Injectable, Optional } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../Combo/combo.service';
import { EmployeeRegistrationService } from '../EmployeeRegistration/employee-registration.service';
import { UtilityService } from '../utility/utility.service';
import { threadId } from 'worker_threads';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { type } from 'jquery';
import { CardDetailComponent } from '../../Dashboard/CardDetail/card-detail/card-detail.component';
import { FullImageComponent } from '../../Component/FullImage/full-image/full-image.component';
import { UserRightService } from '../UserRight/user-right.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { Router } from '@angular/router';
import { ViewImageDocComponent } from '../../Component/view-image-doc/view-image-doc.component';
import path from 'path';
import pako from 'pako';
import { DownloadSampleService } from '../DownloadSample/download-sample.service';
// import { DashboardService } from '../Dashboard/dashboard.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  programmaticTimer = false;
  user = [] as any;
  Status = [{ Name: 'All', Value: 'ALL' }, { Name: 'Pending', Value: 'Pending' }, { Name: 'Approved', Value: 'Approved' }, { Name: 'Rejected', Value: 'Rejected' }]
  SiteStatus = [{ Name: 'All', Value: 'ALL' }, { Name: 'Active', Value: 'Active' }, { Name: 'Deactive', Value: 'Deactive' }]
  EmployeeCategorys: any = [{ EmployeeCategoryID: 1, EmployeeCategory: 'Front', Value: 'Front', disabled: false },
  { EmployeeCategoryID: 2, EmployeeCategory: 'Back', Value: 'Back', disabled: false }]
  TravelTypes = [{ TravelTypeID: 1, TravelType: 'Local', Value: 'Local' },
  { TravelTypeID: 2, TravelType: 'Outstation', Value: 'Outstation' },];
  LimitTypes = [{ LimitTypeID: 1, LimitType: 'Daily', Value: 'Daily' },
  { LimitTypeID: 2, LimitType: 'Monthly', Value: 'Monthly' },
  { LimitTypeID: 3, LimitType: 'Quarterly', Value: 'Quarterly' },
  { LimitTypeID: 4, LimitType: 'Yearly', Value: 'Yearly' },];
  ReimbursementStatus = [{ Name: 'All', Value: 'ALL' }, { Name: 'Pending', Value: 'Pending' }, { Name: 'Approved', Value: 'Approved' }, { Name: 'Rejected', Value: 'Rejected' }, { Name: 'Reimbursed', Value: 'Reimbursed' }, { Name: 'Reimburse Pending', Value: 'Reimburse Pending' }]
  ReimburseStatus = [{ Name: 'Reimbursed', Value: 'Reimbursed' }, { Name: 'Reimburse Pending', Value: 'Reimburse Pending' }]
  monthNames = [{ Name: 'January', Value: 'January', IsEndFinYear: true },
  { Name: 'February', Value: 'February', IsEndFinYear: true },
  { Name: 'March', Value: 'March', IsEndFinYear: true },
  { Name: 'April', Value: 'April', IsEndFinYear: false },
  { Name: 'May', Value: 'May', IsEndFinYear: false },
  { Name: 'June', Value: 'June', IsEndFinYear: false },
  { Name: 'July', Value: 'July', IsEndFinYear: false },
  { Name: 'August', Value: 'August', IsEndFinYear: false },
  { Name: 'September', Value: 'September', IsEndFinYear: false },
  { Name: 'October', Value: 'October', IsEndFinYear: false },
  { Name: 'November', Value: 'November', IsEndFinYear: false },
  { Name: 'December', Value: 'December', IsEndFinYear: false },];

  CompanyParameterValue = {
    RetirementAge: 0,
    WorkAge: 0,
    ProbationDays: 0,
    PreJoiningDate: null as any,
    PostJoiningDate: null as any,
    PhotoFolder: null as any,
    SignatureFolder: null as any,
    AadhaarFolder: null,
    AddressFolder: null,
    BankDetailsFolder: null,
    DrivingLicenseFolder: null,
    GunLicenseFolder: null,
    PanFolder: null,
    QualificationFolder: null,
    LH1Folder: null as any,
    LH2Folder: null as any,
    LH3Folder: null as any,
    LH4Folder: null as any,
    LH5Folder: null as any,
    RH1Folder: null as any,
    RH2Folder: null as any,
    RH3Folder: null as any,
    RH4Folder: null as any,
    RH5Folder: null as any,
    HTTPSDownloadLink: null as any,
    //HTTPSDownloadFolder: null as any,
    RegistrationDate: null as any,
    FirstDateOfMonth: null as any,//add for calender regu;azation 
    PreOnBoarding_IsURLAutoInitiated: null as any,
    SelfAttendancePhoto: null as any,
    MaxAgeAllowed: 0,
    RestrictFutureDateEntry: false,
    RestrictFutureDateEntryBack: false,
    CCCode: false,
    ExpenseFolder: 'Expense',
    DefaultAPIIntegration: false,
    ZingHRAPIIntegration: false,
    ProptorAPIIntegration: false,
    AllowUserToUpdateAllEmpMasterData: false,
    IsShiftRuleFromShiftMaster: false,
    IsESignInAllowed: false,
    ProofAttachment: 'IncomeTaxProof',
    IsFaceCompare: false,
    IsESSAddressAttendanceEnabled: false,
    ESS_DashboardTotalActiveCountEnabled: false,
    RestrictSimplePassword: false,
    ESS_IsEmpBGVApplicable: false,
    PreviousEmployment: 'PreviousEmployment',
    DegreeAttachment: null,
    AllModulesRights: false,
    IsDeviceAttendanceApplicable: false,
    MenualBGVAttachment: 'BGV',
    IsESSAutoFillInternalPOC: false,
    IsESSAutoFillClientPOC: false,
    IsESSSiteMasterChannelCode: false,
    IsESSSiteMasterOracleCode: false,
    ClientRateContractSalary: 'ClientRateContractSalary',
    IPOCAttachment: 'IPOCAttachment',
    PhysicalDisabilityAttachmentFolder: null,
    ESS_IsPhysicalDisabilityAttachmentCompulsory: false
  }

  NotificationCount = 0;
  Documents = [] as any;
  selectedmenuID = 0;
  PeriodTypes = [{ Name: 'Week', Value: 'Week', MaxDay: 7 }, { Name: 'Month', Value: 'Month', MaxDay: 31 }, { Name: 'Quarter', Value: 'Quarter', MaxDay: 93 }, { Name: 'Year', Value: 'Year', MaxDay: 365 }];
  PageRight = {
    IsView: false,
    IsAdd: false,
    IsEdit: false,
    IsDelete: false,
    IsPrint: false,
  }

  MenuCounts = {
    Approval: {
      Leave: 0,
      Regularization: 0,
      Attendance: 0,
      Registration: {
        MenualOnBoard: 0,
        PreOnBoard: 0,
      },
      OptionalHoliday: 0,
      CompensatoryOff: 0,
      CompensatoryOffConsume: 0,
      Reimbursement: 0,
      ExpenseAdvance: 0,
      Expense: 0,
      EmpConfirmation: 0,
      Letter: 0,
      Profile: 0,
      Outdoor: 0,
      TaxDeclaration: 0,
      TaxInvestment: 0,
      DeviceImage: 0,
      ProfileImage: 0,
    },
  }

  fileupload = {
    checkSize: true,
    size: 1024 // in kb,
  }
  TotalPendingCount: number = 0;

  commonDToptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    destroy: true,
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    processing: true,
    responsive: true,
    scrollX: true,
    scrollCollapse: true,
    autoWidth: true,
    lengthChange: true,
    language: {
      searchPlaceholder: 'Search...',
    },
  };

  constructor(
    private http: HttpClient,
    private utility: UtilityService,
    private combo: ComboService,
    private employeeRegistration: EmployeeRegistrationService,
    private session: SessionService,
    private modalService: NgbModal,
    private userright: UserRightService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private router: Router,
    private download: DownloadSampleService,
    // private dashboard: DashboardService
  ) {
    if (this.session.GetUserDetails() != null) {
      if (this.session.GetUserDetails().ApiUrl != null && this.session.GetUserDetails().ApiUrl != '') {
        this.CompanyParameter();
      }
    }
    //this.ComboLoad('document');
    //this.SelectDate('RegistrationDate', null, null);
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.CompanyParameterValue.RegistrationDate = response.Table[0].RegistrationDate;
          //this.CompanyParameterValue.FirstDateOfMonth = moment(Date.UTC(this.CompanyParameterValue.RegistrationDate.year(), this.CompanyParameterValue.RegistrationDate.month(), 1));
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  async CompanyParameter() {
    this.utility.CompanyParameter().subscribe({
      next: (response) => {
        this.CompanyParameterValue.RetirementAge = response.RetirementAge;
        this.CompanyParameterValue.WorkAge = response.WorkAge;
        this.CompanyParameterValue.PreJoiningDate = response.PreJoiningDate;
        this.CompanyParameterValue.ProbationDays = response.ProbationDays;
        this.CompanyParameterValue.PhotoFolder = response.PhotoFolder;
        this.CompanyParameterValue.SignatureFolder = response.SignatureFolder;
        this.CompanyParameterValue.AadhaarFolder = response.AadhaarFolder;
        this.CompanyParameterValue.AddressFolder = response.AddressFolder;
        this.CompanyParameterValue.BankDetailsFolder = response.BankDetailsFolder;
        this.CompanyParameterValue.DrivingLicenseFolder = response.DrivingLicenseFolder;
        this.CompanyParameterValue.GunLicenseFolder = response.GunLicenseFolder;
        this.CompanyParameterValue.PanFolder = response.PanFolder;
        this.CompanyParameterValue.QualificationFolder = response.QualificationFolder;
        this.CompanyParameterValue.LH1Folder = response.LH1Folder;
        this.CompanyParameterValue.LH2Folder = response.LH2Folder;
        this.CompanyParameterValue.LH3Folder = response.LH3Folder;
        this.CompanyParameterValue.LH4Folder = response.LH4Folder;
        this.CompanyParameterValue.LH5Folder = response.LH5Folder;
        this.CompanyParameterValue.RH1Folder = response.RH1Folder;
        this.CompanyParameterValue.RH2Folder = response.RH2Folder;
        this.CompanyParameterValue.RH3Folder = response.RH3Folder;
        this.CompanyParameterValue.RH4Folder = response.RH4Folder;
        this.CompanyParameterValue.RH5Folder = response.RH5Folder;
        this.CompanyParameterValue.HTTPSDownloadLink = response.HTTPSDownloadLink + this.session.GetUserDetails().CompanyCode + '/';
        this.CompanyParameterValue.PreOnBoarding_IsURLAutoInitiated = response.PreOnBoarding_IsURLAutoInitiated;
        this.CompanyParameterValue.SelfAttendancePhoto = response.SelfAttendancePhoto;
        this.CompanyParameterValue.MaxAgeAllowed = response.MaxAgeAllowed;
        this.CompanyParameterValue.RestrictFutureDateEntry = response.RestrictFutureDateEntry;
        this.CompanyParameterValue.RestrictFutureDateEntryBack = response.RestrictFutureDateEntryBack;
        this.CompanyParameterValue.CCCode = response.CCCode;
        this.CompanyParameterValue.DefaultAPIIntegration = response.DefaultAPIIntegration;
        this.CompanyParameterValue.ZingHRAPIIntegration = response.ZingHRAPIIntegration;
        this.CompanyParameterValue.ProptorAPIIntegration = response.ProptorAPIIntegration;
        this.CompanyParameterValue.AllowUserToUpdateAllEmpMasterData = response.AllowUserToUpdateAllEmpMasterData;
        this.CompanyParameterValue.IsShiftRuleFromShiftMaster = response.IsShiftRuleFromShiftMaster;
        this.CompanyParameterValue.IsESignInAllowed = response.IsESignInAllowed;
        this.CompanyParameterValue.IsFaceCompare = response.IsFaceCompare;
        this.CompanyParameterValue.IsESSAddressAttendanceEnabled = response.IsESSAddressAttendanceEnabled;
        this.CompanyParameterValue.ESS_DashboardTotalActiveCountEnabled = response.ESS_DashboardTotalActiveCountEnabled;
        this.CompanyParameterValue.RestrictSimplePassword = response.RestrictSimplePassword;
        this.CompanyParameterValue.ESS_IsEmpBGVApplicable = response.ESS_IsEmpBGVApplicable;
        this.CompanyParameterValue.DegreeAttachment = response.DegreeAttachmentFolder;
        this.CompanyParameterValue.AllModulesRights = response.AllModulesRights;
        this.CompanyParameterValue.IsDeviceAttendanceApplicable = response.ESS_IsDeviceAttendanceApplicable;
        this.CompanyParameterValue.IsESSAutoFillInternalPOC = response.IsESSAutoFillInternalPOC;
        this.CompanyParameterValue.IsESSAutoFillClientPOC = response.IsESSAutoFillClientPOC;
        this.CompanyParameterValue.IsESSSiteMasterChannelCode = response.IsESSSiteMasterChannelCode;
        this.CompanyParameterValue.IsESSSiteMasterOracleCode = response.IsESSSiteMasterOracleCode;
        this.CompanyParameterValue.PhysicalDisabilityAttachmentFolder = response.PhysicalDisabilityAttachmentFolder;
        this.CompanyParameterValue.ESS_IsPhysicalDisabilityAttachmentCompulsory = response.ESS_IsPhysicalDisabilityAttachmentCompulsory;
      },
      complete: () => {
        //this.SelectDate('RegistrationDate', null, null);
      },
      error: (error) => {
      },
    });
  }

  NumberOnly(event: any, allowDot = false, allowNagtive = false): boolean {
    if ((!(event.target.value).includes(".")) || (event.target.value).split('.')[1].length <= 2) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (((allowNagtive == true && charCode != 45 && charCode != 46) || allowNagtive == false) && ((allowDot == true && charCode != 46 && charCode != 45) || allowDot == false) && charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      } else if ((event.target.value).includes(".") && charCode == 46) {
        return false;
      } else if ((event.target.value).includes("-") && charCode == 45) {
        return false;
      } else if (charCode == 45 && event.target.selectionStart > 0) {
        return false;
      } else {
        return true;
      }
    } else {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
      return false;
    }

  }

  AlphabetOnly(event: any, IsSpace = false): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((IsSpace && charCode == 32) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
      return true;
    }
    return false;
  }

  allowDot(No: any) {
    if (No == null) {
      return false;
    } else {
      return !No.includes('.');
    }
  }

  ToLowerCase(Text: String) {
    if (Text != null) {
      return Text.toLowerCase();
    } else {
      return Text;
    }
  }

  ToUpperCase(Text: String) {
    if (Text != null) {
      return Text.toUpperCase();
    } else {
      return Text;
    }
  }

  ToUpperCaseE(event: any) {
    // const element = event.target as HTMLInputElement;
    // const startPos = element.selectionStart;
    // const endPos = element.selectionEnd;
    // element.value = element.value.toUpperCase();
    // element.setSelectionRange(startPos, endPos);

    const element = event.target as HTMLInputElement;
    const startPos = element.selectionStart;
    const endPos = element.selectionEnd;
    const upperValue = element.value.toUpperCase();
    element.value = upperValue;
    element.setSelectionRange(startPos, endPos);
    return upperValue; // Return the uppercase value
  }

  ToUpperCaseC(event: any, callback: ((newValue: string) => void) | null = null): void {
    const element = event.target as HTMLInputElement;
    const startPos = element.selectionStart;
    const endPos = element.selectionEnd;
    element.value = element.value.toUpperCase();
    element.setSelectionRange(startPos, endPos);
    if (callback != null) {
      callback(element.value);
    }
  }

  PhotoLink(Path: String, IsSelfAttendance: boolean = false) {
    if (Path != null && Path != '' && Path != 'null') {
      if (IsSelfAttendance) {
        return this.CompanyParameterValue.HTTPSDownloadLink + '/' + this.CompanyParameterValue.SelfAttendancePhoto + '/' + Path;
      } else {
        return this.CompanyParameterValue.HTTPSDownloadLink + '/' + (this.CompanyParameterValue.PhotoFolder != null ? this.CompanyParameterValue.PhotoFolder : 'Photo') + '/' + Path;
      }
    } else {
      return '../assets/UserProfileImage/EmpDefaultImage.jpg'
    }
  }

  isPdf(url: string) {
    return url.substr((url.lastIndexOf('.'))) == '.pdf';
  }

  checkFileType(url: string) {
    if (url.substr((url.lastIndexOf('.'))).toLowerCase() == '.jpg' || url.substr((url.lastIndexOf('.'))).toLowerCase() == '.jpeg' || url.substr((url.lastIndexOf('.'))).toLowerCase() == '.png') {
      return 1
    } else if (url.substr((url.lastIndexOf('.'))).toLowerCase() == '.pdf') {
      return 2
    } else if (url.substr((url.lastIndexOf('.'))).toLowerCase() == '.xlsx' || url.substr((url.lastIndexOf('.'))).toLowerCase() == '.xls') {
      return 3
    } else if (url.substr((url.lastIndexOf('.'))).toLowerCase() == '.docx' || url.substr((url.lastIndexOf('.'))).toLowerCase() == '.doc') {
      return 4
    } else {
      return 0
    }
  }

  FullImage(Path: String, { ProfileImage = '', Name = '', Code = '', Designation = '', ContactNo = '', MTitle1 = '', MTitle2 = '', MData1 = '', MData2 = '', Address = '', IsAttendanceMatch = '', AttendanceMatchPercentage = '', Latitude = '', Longitude = '' }) {
    const modalRef = this.modalService.open(FullImageComponent, { size: 'lg' });
    modalRef.componentInstance.Datas.ProfileImage = ProfileImage;
    modalRef.componentInstance.Datas.ImgPath = Path;
    modalRef.componentInstance.Datas.Name = Name;
    modalRef.componentInstance.Datas.Code = Code;
    modalRef.componentInstance.Datas.Designation = Designation;
    modalRef.componentInstance.Datas.ContactNo = ContactNo;
    modalRef.componentInstance.Datas.MTitle1 = MTitle1;
    modalRef.componentInstance.Datas.MTitle2 = MTitle2;
    modalRef.componentInstance.Datas.MData1 = MData1;
    modalRef.componentInstance.Datas.MData2 = MData2;
    modalRef.componentInstance.Datas.Address = Address;
    modalRef.componentInstance.Datas.IsAttendanceMatch = IsAttendanceMatch;
    modalRef.componentInstance.Datas.AttendanceMatchPercentage = AttendanceMatchPercentage;
    modalRef.componentInstance.Datas.Latitude = Latitude;
    modalRef.componentInstance.Datas.Longitude = Longitude;
    modalRef.result.then(result => { });
  }

  parseFloat(number: any) {
    return parseFloat(number);
  }

  getInitial(text: String) {
    if (text != null) {
      const stext = text.split(' ').map(name => name[0]).join('').toUpperCase();
      return stext.charAt(0) + stext.charAt(stext.length - 1);
    } else {
      return '';
    }
  }

  getPageRights() {
    this.user = this.session.GetUserDetails()
    // if (this.user.selectedmenuID != 0) {
    //   console.log(this.user.menuname.split('/')[1]);
    // }

    if (!this.user.IsPreOnBoarding) {
      try {
        if (this.selectedmenuID > 0 || this.user.menuname == null || this.router.url == this.user.menuname || this.router.url.split('/')[1] == this.user.menuname.split('/')[1]
          || (this.user.menuname.split('/')[1] == 'dashboard' && this.router.url.split('/')[3] == 'deviceattendance')) {
          this.user.menuname = this.router.url
          if (this.selectedmenuID > 0) {
            this.user.selectedmenuID = this.selectedmenuID;
            this.session.Start(this.user);
          } else {
            if (this.user.selectedmenuID == 0 && this.ToLowerCase(this.router.url.split('/')[1]) == 'home') {
              this.selectedmenuID = 2;
            } else if (this.user.selectedmenuID == 0 && this.ToLowerCase(this.router.url.split('/')[3]) == 'deviceattendance') {
              this.selectedmenuID = 342;
            } else {
              this.selectedmenuID = this.user.selectedmenuID;
            }
          }
          return this.userright.ESS_ProfileMenuRightsView({ SelectType: 'GetRights', ESS_MenuMasterId: this.selectedmenuID }).subscribe({
            next: (response) => {

              if (response.Table && response.Table.length > 0) {
                this.PageRight = {
                  IsView: response.Table[0].IsView,
                  IsAdd: response.Table[0].IsAdd,
                  IsEdit: response.Table[0].IsEdit,
                  IsDelete: response.Table[0].IsDelete,
                  IsPrint: response.Table[0].IsPrint,
                }
                if (this.selectedmenuID > 1) {
                  if (!this.PageRight.IsView) {
                    alert('SORRY YOU ARE NOT AUTHORIZED TO VIEW THIS PAGE 1');
                    if (this.user.UserType == 'A') {
                      this.router.navigate(['dashboard/front'], { replaceUrl: true });
                    } else if (this.user.UserType == 'E') {
                      this.router.navigate(['home/'], { replaceUrl: true });
                    }
                    // this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
                    // this.session.End();
                  }
                }
              } else {
                alert('SORRY YOU ARE NOT AUTHORIZED TO VIEW THIS PAGE 2');
                if (this.user.UserType == 'A') {
                  this.router.navigate(['dashboard/front'], { replaceUrl: true });
                } else if (this.user.UserType == 'E') {
                  this.router.navigate(['home/'], { replaceUrl: true });
                }
              }
              return true;
            },
            complete: () => { },
            error: (error) => { },
          });
        } else {
          alert('SORRY YOU ARE NOT AUTHORIZED TO VIEW THIS PAGE 3');
          if (this.user.UserType == 'A') {
            this.router.navigate(['dashboard/front'], { replaceUrl: true });
          } else if (this.user.UserType == 'E') {
            this.router.navigate(['home/'], { replaceUrl: true });
          }
          //this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
          //this.session.End();
          return true;
        }
      } catch (e) {
        return true;
      }
    } else { return true; }

  }

  ViewImageDoc(Path: string) {
    if (this.checkFileType(Path) == 1 || this.checkFileType(Path) == 2) {
      const modalRef = this.modalService.open(ViewImageDocComponent, { size: 'xl' });
      modalRef.componentInstance.ImageDocPath = Path;
      modalRef.result.then(result => { });
    } else {
      window.location.assign(Path);
    }
  }

  getCommonConfig(): DataTables.Settings {
    return {
      pagingType: 'full_numbers',
      searching: true,
      pageLength: 10,
      lengthMenu: [10, 25, 50, 100],
      processing: true,
      responsive: true,
      scrollX: true,
      scrollCollapse: false,
      autoWidth: true,
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search...',
      },
    };
  }

  IsMobile() {
    if (window.innerWidth < 768) {
      return true;
    } else {
      return false;
    }
  }

  ExcelDump(filename: string, data: any) {
    const jsonString = JSON.stringify(data);
    const compressed = pako.deflate(jsonString);
    const base64String = btoa(String.fromCharCode(...compressed));

    // Now decode and decompress:
    const binaryString = atob(base64String);
    const compressedData = Uint8Array.from(binaryString, c => c.charCodeAt(0));
    const decompressedData = pako.inflate(compressedData, { to: 'string' });
    const exceldata = JSON.parse(decompressedData);

    if (exceldata.length > 0) {
      this.download.exportInChunks(exceldata, filename);
    } else {
      this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
    }
  }

  addDaysToNgbDate(ngbDate: any, days: number): any {
    if (!ngbDate) return null;

    // Convert NgbDateStruct to JavaScript Date
    const jsDate = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);

    // Add days
    jsDate.setDate(jsDate.getDate() + days);

    // Convert back to NgbDateStruct
    return {
      year: jsDate.getFullYear(),
      month: jsDate.getMonth() + 1,
      day: jsDate.getDate()
    };
  }

  CheckSubscriptionExpiry(Detail: any) {
    const token = sessionStorage.getItem('Token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.post<any>(`https://productsubscriptionapi.maxus.co.in/ClientProductSubscriptionDue`,
      Detail, { headers }
    ).pipe(map(response => {
      return response;
    }));
  }

  CheckExpiry() {
    this.CheckSubscriptionExpiry({
      ClientCode: this.session.GetUserDetails().CompanyCode,
      ClientName: "",
      ProductName: "HRMS and TAMS"
    }).subscribe({
      next: (response) => {
        if (response.Error_Code == '02') {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            keyboard: false,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result) => {
            this.utility.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.session.GetUserDetails().LoginName }).subscribe({
              next: (response) => {
                if (response.Error_Code == "09")
                  this.session.End();
              },
              complete: () => { },
              error: (error) => { },
            });
          })
        } else {
          if (response.Error_Code == '00') {
            return;
          }
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            keyboard: false,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
        }
      },
      complete: () => { },
      error: (error) => {
        console.log(error);
        this.StoreToken();
      },
    });
  }

  GetToken(Detail: any) {
    return this.http.post<any>(`https://productsubscriptionapi.maxus.co.in/GenerateToken`,
      Detail
    ).pipe(map(response => {
      return response;
    }));
  }

  StoreToken() {
    this.GetToken({
      SelectType: "Admin",
      Username: "Admin@1405",
      Password: "AppAdmin@1405"
    }).subscribe({
      next: (response) => {
        sessionStorage.setItem('Token', response.Token);
        this.CheckExpiry();
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  public handleDownload(blob: Blob, filename: string) {
    saveAs(blob, filename);
  }

  public getDateRange(fromDate: Date, toDate: Date): Date[] {
    const dates: Date[] = [];
    const currentDate = new Date(fromDate);

    while (currentDate <= toDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  }

  public getDateRangeFormatted(fromDate: Date, toDate: Date, format: string = 'dd MMM yyyy'): string[] {
    const dates = this.getDateRange(fromDate, toDate);
    return dates.map(date => {
      // You can use Angular's DatePipe or custom formatting
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    });
  }
}